import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default class Fixture {

  constructor () {
    this.storage = localStorage
    this.fixtures = []
  }

  generate (data) {
    return Vue.http.post(configure.api_url + 'fixtures',
     data
   ).then(response => {
     return response
   })
  }

  get (id) {
    return Vue.http.get(configure.api_url + 'fixtures/' + id)
    .then(response => {
      return response
    })
  }

  setLocal (key, data) {
    let fixtures = JSON.parse(this.storage.getItem('fixtures'))
    if (!Array.isArray(fixtures)) {
      console.log('Nuevo array')
      fixtures = []
    }
    let index = fixtures.findIndex((element) => {
      return element.key == key
    })
    if (index < 0) {
      fixtures.push({key: key, data: data})
    } else {
      fixtures[index] = {key: key, data: data}
    }
    this.storage.setItem('fixtures', JSON.stringify(fixtures))
  }

  getLocal (key) {
    let fixtures = JSON.parse(this.storage.getItem('fixtures'))
    if (!Array.isArray(fixtures)) {
      console.log('No Hay Datos')
      fixtures = []
    }
    return fixtures[key]
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/fixture.js
 **/